import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import router from './router'
import store from './store'
import './style'
import '@/libs/vconsole';
import '@/libs/polyfill';
import 'vant/lib/index.css'; // 引入Vant css文件
Vue.use(Vant);

// 某些宿主 WebView 在前后台切换时会直接执行这些全局函数。
// H5 侧没有实现时会抛 ReferenceError，先提供安全兜底避免页面崩溃。
const noopViewLifecycleHandler = () => {};
window.moniterViewAppear = window.moniterViewAppear || noopViewLifecycleHandler;
window.moniterViewDisappear = window.moniterViewDisappear || noopViewLifecycleHandler;
window.monitorViewAppear = window.monitorViewAppear || noopViewLifecycleHandler;
window.monitorViewDisappear = window.monitorViewDisappear || noopViewLifecycleHandler;

// 计算当前页面 配置屏幕的大小的rem 默认750宽度
window.onresize = () => {
  return (() => {
    onresizeFun();
  })();
};
/* eslint-disable */
function onresizeFun() {
  let Dpr = 1;
  let uAgent = window.navigator.userAgent;
  let isIOS = uAgent.match(/iphone/i);
  let isYIXIN = uAgent.match(/yixin/i);
  let is2345 = uAgent.match(/Mb2345/i);
  let ishaosou = uAgent.match(/mso_app/i);
  let isSogou = uAgent.match(/sogoumobilebrowser/ig);
  let isLiebao = uAgent.match(/liebaofast/i);
  let isGnbr = uAgent.match(/GNBR/i);
  function isPc() {
    if (uAgent.match(/(iPhone|Android|SymbianOS|Windows Phone|iPod|iPad)/i)) {
      return false;
    } else {
      return true;
    }
  }
  let wWidth = (screen.width > 0) ? (window.innerWidth >= screen.width || window.innerWidth === 0) ? screen.width :
    window.innerWidth : window.innerWidth;
  let wDpr; let
    wFsize;
  let wHeight = (screen.height > 0) ? (window.innerHeight >= screen.height || window.innerHeight === 0) ? screen.height :
    window.innerHeight : window.innerHeight;
  if (window.devicePixelRatio) {
    wDpr = window.devicePixelRatio;
  } else {
    wDpr = isIOS ? wWidth > 818 ? 3 : wWidth > 480 ? 2 : 1 : 1;
  }
  if (isIOS) {
    wWidth = screen.width;
    wHeight = screen.height;
  }
  if (wWidth > wHeight) {
    wWidth = wHeight;
  }
  wFsize = wWidth > 480 ? 64 : wWidth / 7.5;
  wFsize = wFsize > 32 ? wFsize : 32;
  window.screenWidth_ = wWidth;
  if (isYIXIN || is2345 || ishaosou || isSogou || isLiebao || isGnbr) { // YIXIN 和 2345 这里有个刚调用系统浏览器时候的bug，需要一点延迟来获取
    setTimeout(function () {
      wWidth = (screen.width > 0) ? (window.innerWidth >= screen.width || window.innerWidth === 0) ? screen.width :
        window.innerWidth : window.innerWidth;
      wHeight = (screen.height > 0) ? (window.innerHeight >= screen.height || window.innerHeight ===
              0) ? screen.height : window.innerHeight : window.innerHeight;
      wFsize = wWidth > 480 ? 64 : wWidth / 7.5;
      wFsize = wFsize > 32 ? wFsize : 32;
      window.document.getElementsByTagName('html')[0].style.fontSize = wFsize + 'px';
    }, 500);
  } else {
    window.document.getElementsByTagName('html')[0].style.fontSize = wFsize + 'px';
  }
}
onresizeFun()

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
